module.exports = __webpack_public_path__ + "img/image-slider-02.f0cfa8d4.jpg";